import { TuVantageScore3Buckets } from '@generated-gql/generated-types';
import { TierRanges, HORIZONTAL_GAUGE_WIDTHS } from './constants';
import { CREDIT_SCORE_IDENTITY_PROFILE_QUERY } from './credit-meter';

export const getCreditScoreTierPercentage = (scoreTier, score) => {
  const { min: tierMin, max: tierMax } = TierRanges[scoreTier];
  return (score - tierMin) / (tierMax - tierMin);
};

export const getMarkerLocation = (scoreTier, score) => {
  scoreTier = scoreTier.toUpperCase();
  const percentageInTier = getCreditScoreTierPercentage(scoreTier, score);
  const section = HORIZONTAL_GAUGE_WIDTHS[scoreTier];
  const sectionWidth = section.percentageOfTotal * percentageInTier;
  return section.start + sectionWidth;
};

export const capitalizeFirstLetter = (string) => {
  return string?.charAt(0).toUpperCase() + string?.slice(1).toLowerCase();
};

export const getTierFromScore = (score) => {
  const tierRange = Object.entries(TierRanges).find(
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    ([_, { min, max }]) => score >= min && score <= max,
  );
  if (!tierRange) {
    return TuVantageScore3Buckets.Poor;
  }
  return tierRange[0];
};

export const mockCreditScoreResponse = () => ({
  request: {
    query: CREDIT_SCORE_IDENTITY_PROFILE_QUERY,
  },
  result: {
    data: {
      tuCreditReportIdentityProfile: {
        vantageScore3: 690,
        vantageScore3Bucket: 'GOOD',
        reportPulledAt: '2024-10-01T12:00:00Z',
      },
    },
  },
});
